import { TemplateResult, html, CSSResultGroup } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-form.css.lit';
import { OutlineForm } from '../../base/outline-form/outline-form';
import { SlotController } from '../../controllers/slot-controller';

type colsAvailable = 1 | 2 | 3;
/**
 * The Idb Form component
 * @element idb-form
 */
@customElement('idb-form')
export class IdbForm extends OutlineForm {
  slots = new SlotController(
    this, // This, the host element.
    true // To shift or not to shift LightDom nodes to ShadowDOM.
  );
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Create a grid with n equally sized columns.
   */
  @property({ type: Number })
  cols: colsAvailable;

  render(): TemplateResult {
    const classes = {
      [`idb-form--columns-${this.cols}`]: this.cols,
    };

    return html`
    <div class=${classMap(classes)}>
      <slot name="form"></slot>
      <slot></slot>
    </div>`;
  }
}
